module.exports = __webpack_public_path__ + "img/portrait-039.21990a5e.jpg";